import React from 'react';

const FooterButtons = ({ onClose }) => {
  const styleButtons = {
    borderRadius: '20px',
  };

  return (
    <>
      <button onClick={onClose} type="button" className="btn btn-outline-secondary btn-sirio" style={styleButtons}>
        <i className="fa fa-times"></i> Cancelar
      </button>
      <button type="submit" className="btn btn-outline-secondary btn-sirio" style={styleButtons}>
        <i className="fa fa-save"></i> Guardar
      </button>
    </>
  );
};

export default FooterButtons;
